import { HStack } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { QuickFilter } from "@src/components/modules/projects/list/Store";
import { NavBar } from "@src/components/ui-kit";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";

export const ClientsProjectListNavBar = observer(
  function ClientsProjectListNavBar() {
    const { projectListingForClientsStore: store } = useStore();

    return (
      <HStack justifyContent="space-between">
        <NavBar>
          <NavBar.Item
            active={!store.quickFilter.value.length}
            onClick={() => store.quickFilter.clear()}
          >
            <Trans>All</Trans>
          </NavBar.Item>

          <NavBar.Item
            active={store.quickFilter.value[0] === QuickFilter.Active}
            onClick={() => store.quickFilter.setValue(QuickFilter.Active)}
          >
            <Trans>All Active</Trans>
          </NavBar.Item>

          <NavBar.Item
            active={store.quickFilter.value[0] === QuickFilter.Finished}
            onClick={() => store.quickFilter.setValue(QuickFilter.Finished)}
          >
            <Trans>Finished</Trans>
          </NavBar.Item>

          <NavBar.Item
            active={store.quickFilter.value[0] === QuickFilter.Archived}
            onClick={() => store.quickFilter.setValue(QuickFilter.Archived)}
          >
            <Trans>Archived</Trans>
          </NavBar.Item>
        </NavBar>
      </HStack>
    );
  },
);
